var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"left"},[_c('top-banner',{staticClass:"banner"}),_c('login-info',{staticClass:"login-info"}),(_vm.isLogin)?_c('func-union',{staticClass:"func-union"}):_vm._e(),_c('safe-footer'),_c('page-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }